/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Observable } from 'rxjs';
import {Property} from './property'  ;
import { ObjectInstance } from './object-instance';

export class InstanceData {
  id: number;
  property: Property;
  value: string;
  object_value: any;
  isEditing: boolean = false;
  instanceResults$?: Observable<any[]>;
}
